import { maybe } from "@saleor/misc";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import { GetRemittance_remittance_remittanceLines_order } from "@saleor/remittanceRunner/types/GetRemittance";
import { RemittanceRunnerOrders_remittanceOrders_edges_node } from "@saleor/remittanceRunner/types/RemittanceRunnerOrders";
import {
  getOrderManuallyAdjustedAmount,
  isOrderManuallyAdjusted
} from "@saleor/remittanceRunner/utils/handlers";
import { currencyFormat } from "@saleor/utils/formatters/currencyFormat";
import React from "react";

interface RemittanceRunnerTblColPaymentTypeGrossAmountProp {
  paymentMethodType: string;
  amount: number;
  isRemittanceAmount?: boolean;
  remittanceOrder?:
    | RemittanceRunnerOrders_remittanceOrders_edges_node
    | GetRemittance_remittance_remittanceLines_order;
}

export const RemittanceRunnerTblColPaymentTypeGrossAmount: React.FC<RemittanceRunnerTblColPaymentTypeGrossAmountProp> = props => {
  const {
    paymentMethodType,
    amount,
    remittanceOrder,
    isRemittanceAmount
  } = props;
  const tblClasses = useTableStyles(props);

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>Payment Type</div>
      <div className={tblClasses.dataDisplay}>
        {maybe(() => paymentMethodType && amount !== undefined) ? (
          <div>
            <div>{paymentMethodType?.toUpperCase()}</div>
            {maybe(() => isRemittanceAmount) ? (
              <div>{currencyFormat(amount)}</div>
            ) : (
              <div>
                {isOrderManuallyAdjusted(remittanceOrder)
                  ? currencyFormat(
                      getOrderManuallyAdjustedAmount(remittanceOrder)
                    )
                  : currencyFormat(amount)}
              </div>
            )}
          </div>
        ) : (
          <span>-----</span>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColPaymentTypeGrossAmount;
